<template>
  <multiselect
    @search-change="debounceSelectChange"
    v-model="input"
    :placeholder="placeholder"
    :selectLabel="selectLabel"
    :deselectLabel="deselectLabel"
    :internalSearch="isInternalSearch"
    :preserveSearch="isResetAfter"
    :options="selectOptions"
    :disabled="isDisabled"
    :show-labels="false"
    :allowEmpty="false"
    :custom-label="displayThaiAndEngLabel"
    :class="{ 'is-invalid': isError ? 1 : 0 }"
    @select="onSelect"
  >
    <span slot="noOptions">ไม่พบข้อมูล</span>
    <span slot="noResult">ไม่พบข้อมูลที่ค้นหา</span>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'SelectSelectorComponent',
  components: {
    Multiselect,
  },
  props: {
    options: {
      type: Array,
      default: null,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    numberCharacters: {
      type: Number,
      default: 1,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    preserveSearch: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return this.input
      },
    },
    placeholder: {
      type: String,
      default: 'ระบุข้อมูลเพื่อค้นหา',
    },
    selectLabel: {
      type: String,
      default: 'เลือก',
    },
    deselectLabel: {
      type: String,
      default: '',
    },
    noResult: {
      type: String,
      default: 'ไม่พบข้อมูลที่ค้นหา',
    },
  },
  created() {
    this.debounceSelectChange = this.debounce(this.onSearchChange, 1000)
  },
  mounted() {
    this.input = ''
    this.setDefaultSelected()
  },
  data() {
    return {
      input: null,
      lastSearchValue: '',
      isSearchAble: true,
      isInternalSearch: true,
      isResetAfter: false,
      selectOptions: [],
    }
  },
  watch: {
    value: {
      handler(val) {
        if (
          val !== null &&
          val !== undefined &&
          val !== '' &&
          val !== this.input
        ) {
          this.setDefaultSelected()
        }
      },
      deep: true,
    },
    input: function(val) {
      if (val !== null && val !== undefined && val !== '') {
        this.$emit('input', val)
      }
    },
    preserveSearch: function(val) {
      if (val) {
        this.onReset()
      }
    },
    options: function(val) {
      if (val) {
        this.selectOptions = val
        // ใช้สำหรับบังคับ Data Binding แก้ปัญหา ข้อมูลไม่ถูก Binding ใน Dropdown Selector
        setTimeout(() => {
          this.isInternalSearch = false
        }, 1000)
        setTimeout(() => {
          this.isInternalSearch = true
        }, 1000)
      }
    },
  },
  methods: {
    debounce(fn, interval) {
      let timer
      return function debounce() {
        clearTimeout(timer)
        let args = arguments
        let that = this
        timer = setTimeout(function callOrginalFn() {
          fn.apply(that, args)
        }, interval)
      }
    },
    displayThaiAndEngLabel({ display_name, is_own_brand }) {
      return display_name && (display_name.en || display_name.th)
        ? `${display_name.th}  :  ${display_name.en} ${
            is_own_brand ? '(Own Brand)' : ''
          }`
        : ''
    },
    setDefaultSelected() {
      if (
        this.value &&
        this.value !== '' &&
        this.value.display_name &&
        (this.value.display_name.en || this.value.display_name.th)
      ) {
        //    กรณีดึงข้อมูล Option ใหม่ด้วย
        // let keys = this.value.display_name.en
        //   ? this.value.display_name.en
        //   : this.value.display_name.th
        // this.onSearchChange(keys)
        // this.input = this.value
        //end กรณีดึงข้อมูล Option ใหม่ด้วย

        this.selectOptions = []
        this.selectOptions.push(this.value)
        this.input = this.value
      }
    },
    onReset() {
      this.selectOptions = []
      this.isResetAfter = true
    },
    onSearchChange(val) {
      //Clear when text on selector is emtry
      if (
        (val == null || val == undefined || val == '') &&
        (this.input == null || this.input == undefined)
      ) {
        this.onReset()
      }
      // Keep last search value
      this.lastSearchValue = val
      if (
        this.isSearchAble &&
        this.lastSearchValue &&
        this.lastSearchValue.length >= this.numberCharacters
      ) {
        this.isSearchAble = false
        this.$emit('get', this.lastSearchValue)
        this.isSearchAble = true
      }
    },
    onSelect(selectedOption, id) {
      this.$emit('select', selectedOption)
    },
  },
}
</script>
